// src/components/Login.js

import React from 'react';
import { auth, googleProvider, db } from '../config/firebase';
import { signInWithPopup } from 'firebase/auth';
import { doc, setDoc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore';

// MUI Imports
import Button from '@mui/material/Button';
import GoogleIcon from '@mui/icons-material/Google';
import { Box, Typography, Paper } from '@mui/material';

const Login = () => {
    const handleGoogleSignIn = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;
            
            const userDocRef = doc(db, 'users', user.uid);
            const userDoc = await getDoc(userDocRef);

            if (!userDoc.exists()) {
                await setDoc(userDocRef, {
                    displayName: user.displayName, email: user.email, photoURL: user.photoURL,
                    uid: user.uid, lastSeen: serverTimestamp(), connections: [] 
                });
            } else {
                await updateDoc(userDocRef, { lastSeen: serverTimestamp() });
            }
        } catch (error) {
            console.error("Error during sign in:", error);
        }
    };

    return (
        <Box sx={{ position: 'relative', height: '100vh', width: '100vw', overflow: 'hidden' }}>
            {/* --- 1. THE VIDEO BACKGROUND --- */}
            <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    left: '50%',
                    top: '50%',
                    objectFit: 'cover',
                    transform: 'translate(-50%, -50%)',
                    zIndex: -1,
                }}
            >
                {/* The path is relative to the 'public' folder */}
                <source src="/videos/background.mp4" type="video/mp4" />
            </video>
            {/* --- END VIDEO BACKGROUND --- */}

            {/* Dark overlay to ensure text readability */}
            <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}/>
            
            <Box 
                sx={{ 
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100%',
                }}
            >
                {/* --- 2. RESTYLED "ARCANE" LOGIN BOX --- */}
                <Paper 
                    elevation={12} 
                    sx={{ 
                        padding: { xs: 3, sm: 5 },
                        textAlign: 'center', 
                        borderRadius: 4,
                        width: { xs: '90%', sm: 'auto' },
                        maxWidth: '450px',
                        // Frosted glass effect
                        backgroundColor: 'rgba(10, 25, 41, 0.7)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(76, 201, 240, 0.3)',
                        color: '#FFFFFF', // Set default text color to white
                    }}
                >
                    <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                        Welcome to Zinlanka
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 4, color: '#F2F2F2' }}>
                        Sign in to connect with others
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<GoogleIcon />}
                        onClick={handleGoogleSignIn}
                        size="large"
                        sx={{
                            backgroundColor: '#4AA8FF',
                            color: '#FFFFFF',
                            fontWeight: 'bold',
                            padding: '10px 24px',
                            textTransform: 'none',
                            fontSize: '1rem',
                            border: '1px solid #003d99',
                            '&:hover': {
                                backgroundColor: '#5FC7FF',
                            }
                        }}
                    >
                        Sign in with Google
                    </Button>
                </Paper>
            </Box>
        </Box>
    );
};

export default Login; // <-- THIS LINE IS NOW CORRECTED